import { render } from "./InvitesView.vue?vue&type=template&id=07a07779&scoped=true"
import script from "./InvitesView.vue?vue&type=script&lang=js"
export * from "./InvitesView.vue?vue&type=script&lang=js"

import "./InvitesView.vue?vue&type=style&index=0&id=07a07779&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07a07779"]])

export default __exports__